module.exports = __webpack_public_path__ + "img/zggsyh.4a402132.png";